import { render, staticRenderFns } from "./v-send-codecopy.vue?vue&type=template&id=2c2d0d60&scoped=true&"
import script from "./v-send-codecopy.vue?vue&type=script&lang=js&"
export * from "./v-send-codecopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d0d60",
  null
  
)

export default component.exports